import { EventBus } from "@xbs/lib-state";
import ActionQueue from "./ActionQueue";
export default class RestDataProvider extends EventBus {
    constructor(url) {
        super();
        this._url = url;
        this._queue = new ActionQueue();
        const defaultHandlers = {
            "add-event": {
                ignoreID: true,
                handler: (data) => this.send("events", "POST", data.event),
            },
            "update-event": {
                handler: (data) => this.send(`events/${data.id}`, "PUT", data.event),
            },
            "delete-event": {
                handler: (data) => this.send(`events/${data.id}`, "DELETE"),
            },
            "add-calendar": {
                ignoreID: true,
                handler: (data) => this.send("calendars", "POST", data.calendar),
            },
            "update-calendar": {
                handler: (data) => this.send(`calendars/${data.id}`, "PUT", data.calendar),
            },
            "delete-calendar": {
                handler: (data) => this.send(`calendars/${data.id}`, "DELETE"),
            },
        };
        const handlers = this.getHandlers(defaultHandlers);
        for (const x in handlers) {
            this.on(x, (ev) => this._queue.add(x, ev, handlers[x]));
        }
    }
    getEvents() {
        return this.send("events", "GET").then(this.parseEvents);
    }
    getCalendars() {
        return this.send("calendars", "GET");
    }
    getHandlers(handlers) {
        return handlers;
    }
    send(url, method, data, customHeaders = {}) {
        const headers = {
            "Content-Type": "application/json",
            ...customHeaders,
        };
        const req = {
            method,
            headers,
        };
        if (data) {
            req.body = typeof data === "object" ? JSON.stringify(data) : data;
        }
        return fetch(`${this._url}/${url}`, req).then(res => res.json());
    }
    parseEvents(data) {
        for (let i = 0; i < data.length; i++) {
            data[i].start_date = new Date(data[i].start_date);
            data[i].end_date = new Date(data[i].end_date);
        }
        return data;
    }
}
//# sourceMappingURL=RestDataProvider.js.map